"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMemberPhone = exports.getPhoneDisplayValue = exports.sanitizePhoneNumber = exports.parsePhoneType = exports.initPhoneItem = void 0;
const libphonenumber_js_1 = require("libphonenumber-js");
const types_1 = require("@smartsuite/types");
const phone_1 = require("../safe-field-value/type-checking/phone");
function initPhoneItem(phoneNumber, phoneString) {
    return {
        phone_country: phoneNumber ? phoneNumber.country : types_1.DEFAULT_COUNTRY,
        phone_number: phoneNumber ? phoneNumber.number : phoneString,
        phone_type: parsePhoneType(phoneString),
        phone_extension: "",
    };
}
exports.initPhoneItem = initPhoneItem;
function parsePhoneType(phone) {
    var _a;
    const phoneTypeString = phone.replace(/[^A-Za-z]+/g, "");
    const phoneTypeEntry = Object.entries(types_1.phoneTypeTitles).find(([, value]) => value === phoneTypeString);
    const phoneType = (_a = phoneTypeEntry === null || phoneTypeEntry === void 0 ? void 0 : phoneTypeEntry[0]) !== null && _a !== void 0 ? _a : null;
    return parseInt(phoneType !== null && phoneType !== void 0 ? phoneType : "1", 10);
}
exports.parsePhoneType = parsePhoneType;
function sanitizePhoneNumber(value) {
    return value.replace(/[^a-zA-Z0-9]/g, "").replace(/\D+/g, "");
}
exports.sanitizePhoneNumber = sanitizePhoneNumber;
function getPhoneDisplayValue(value, country = types_1.DEFAULT_COUNTRY) {
    var _a;
    const phoneNumber = (0, libphonenumber_js_1.parsePhoneNumberFromString)(value, country);
    if (phoneNumber && phoneNumber.country === types_1.DEFAULT_COUNTRY) {
        return phoneNumber.formatNational();
    }
    return (_a = phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.formatInternational()) !== null && _a !== void 0 ? _a : "";
}
exports.getPhoneDisplayValue = getPhoneDisplayValue;
/**
 * Get phone number from PhoneItem or OptimizedPhoneItem.
 *
 * @param value
 */
function getMemberPhone(value) {
    if ((0, phone_1.isOptimizedPhone)(value)) {
        return (0, phone_1.optimizedPhoneToPhone)(value);
    }
    return value;
}
exports.getMemberPhone = getMemberPhone;
